<template>
  <div class="sm:flex flex-wrap justify-center mx-auto max-w-2xl sm:space-x-8">
    <product-list-item productName="Crédito personal" v-model="activeProduct">
      <svg class="h-16 w-16 md:h-24 md:w-24 mx-auto" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path class="icon-product-primary" d="M9 11a4 4 0 1 1 0-8 4 4 0 0 1 0 8z" />
        <path
          class="icon-product-secondary"
          d="M16 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-1a5 5 0 0 1 5-5h4a5 5 0 0 1 5 5v1zm1-8.41l3.3-3.3a1 1 0 0 1 1.4 1.42l-4 4a1 1 0 0 1-1.4 0l-2-2a1 1 0 1 1 1.4-1.42l1.3 1.3z"
        />
      </svg>
    </product-list-item>
    <!--  <product-list-item productName="Irme de viaje" v-model="activeProduct">
      <svg class="h-16 w-16 md:h-24 md:w-24 mx-auto" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path
          class="icon-product-secondary"
          d="M19 11.9l2.7 1.14c.18.08.3.26.3.46v2a.5.5 0 0 1-.6.49L12 14 2.6 16a.5.5 0 0 1-.6-.49v-2c0-.2.12-.38.3-.46L5 11.9V10a1 1 0 1 1 2 0v1.06l4.8-2.02a.5.5 0 0 1 .4 0l4.8 2.02V10a1 1 0 0 1 2 0v1.9z"
        />
        <path class="icon-product-primary" d="M12 2a2 2 0 0 1 2 2v8l-1 8h-2l-1-8V4c0-1.1.9-2 2-2z" />
        <path
          class="icon-product-secondary"
          d="M8.64 22.98c-.32.1-.64-.17-.64-.54v-1.1c0-.19.08-.35.2-.46l3.5-2.78c.18-.13.42-.13.6 0l3.5 2.78c.12.1.2.27.2.45v1.11c0 .37-.32.64-.64.54L12 21.9l-3.36 1.07z"
        />
      </svg>
    </product-list-item>
    <product-list-item productName="Mi primer crédito" v-model="activeProduct">
      <svg class="h-16 w-16 md:h-24 md:w-24 mx-auto" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path class="icon-product-primary" d="M3 6l9 4v12l-9-4V6zm14-3v2c0 1.1-2.24 2-5 2s-5-.9-5-2V3c0 1.1 2.24 2 5 2s5-.9 5-2z" />
        <polygon class="icon-product-secondary" points="21 6 12 10 12 22 21 18" />
      </svg>
    </product-list-item> -->
    <product-list-item productName="Prestanómina" v-model="activeProduct">
      <svg class="h-16 w-16 md:h-24 md:w-24 mx-auto" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
        <g id="Rectangle_17">
          <g>
            <polygon fill="#DFEAF7" points="47,24 47,17 17,17 17,24 1,24 1,63 63,63 63,24 		" />
          </g>
        </g>
        <g id="Rectangle_20">
          <g>
            <rect x="29" y="55" fill="#8DB1DE" width="6" height="8" />
          </g>
        </g>
        <g id="Rectangle_21">
          <g>
            <rect x="22" y="1" fill="#A3D9CF" width="20" height="16" />
          </g>
        </g>
        <g id="Rectangle_16">
          <g>
            <path
              fill="#2B3139"
              d="M37,30h-4v4h4V30z M36,8h-3V5c0-0.553-0.447-1-1-1s-1,0.447-1,1v3h-3c-0.553,0-1,0.447-1,1
                    c0,0.552,0.447,1,1,1h3v3c0,0.553,0.447,1,1,1s1-0.447,1-1v-3h3c0.553,0,1-0.448,1-1C37,8.447,36.553,8,36,8z M43,46h-4v4h4V46z
                    M43,22h-4v4h4V22z M37,22h-4v4h4V22z M43,38h-4v4h4V38z M8,46H4v4h4V46z M14,54h-4v4h4V54z M14,46h-4v4h4V46z M14,38h-4v4h4V38z
                    M14,30h-4v4h4V30z M8,30H4v4h4V30z M37,38h-4v4h4V38z M8,38H4v4h4V38z M8,54H4v4h4V54z M43,30h-4v4h4V30z M60,46h-4v4h4V46z
                    M54,30h-4v4h4V30z M60,54h-4v4h4V54z M60,38h-4v4h4V38z M62,23H48v-5c0-1.104-0.896-2-2-2h-3V2c0-1.104-0.896-2-2-2H23
                    c-1.104,0-2,0.896-2,2v14h-3c-1.104,0-2,0.896-2,2v5H2c-1.104,0-2,0.896-2,2v37c0,1.104,0.896,2,2,2h15h30h15c1.104,0,2-0.896,2-2
                    V25C64,23.896,63.104,23,62,23z M16,62H2V25h14V62z M23,2h18v14H23V2z M34,62h-4v-6h4V62z M46,62H36v-8h-8v8H18V18h28V62z M62,62
                    H48V25h14V62z M54,38h-4v4h4V38z M54,54h-4v4h4V54z M60,30h-4v4h4V30z M54,46h-4v4h4V46z M37,46h-4v4h4V46z M31,46h-4v4h4V46z
                    M31,30h-4v4h4V30z M31,38h-4v4h4V38z M31,22h-4v4h4V22z M25,22h-4v4h4V22z M25,46h-4v4h4V46z M25,38h-4v4h4V38z M25,30h-4v4h4V30
                    z"
            />
          </g>
        </g>
      </svg>
    </product-list-item>
  </div>
</template>

<script lang="ts">
import { Component, Watch, Vue } from "vue-property-decorator";
import ProductListItem from "@/components/ProductListItem.vue";

@Component({
  components: {
    ProductListItem
  }
})
export default class ProductList extends Vue {
  activeProduct = "";

  @Watch("activeProduct")
  onProductChanged(val: string): void {
    this.$emit("changed", val);
  }
}
</script>

<style lang="scss">
.icon-product-primary {
  fill: #84c5f4;
}
.icon-product-secondary {
  fill: #0f609b;
}
</style>
